import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerSupplierShippingParams } from '~/types/vender.types';

const usePostOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const postOwnerSupplierShipping = useAPI<TypePostOwnerSupplierShippingParams>({
    endpoint: '/api-owner/owner-supplier',
    method: 'post',
  });

  const registerOwnerSupplierShipping = async (
    { ownerSupplierCode, params }: { ownerSupplierCode: string; params: TypePostOwnerSupplierShippingParams },
    { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}
  ) => {
    runAsync(() => postOwnerSupplierShipping({ params, pathParams: `/${ownerSupplierCode}/shipping` }), {
      onSuccess,
      onError: (error) => {
        toastService.addToast({
          type: 'error',
          message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.();
      },
    });
  };

  return { registerOwnerSupplierShipping };
};

export default usePostOwnerSupplierShipping;
